module.exports = __webpack_public_path__ + "static/media/Sathwik-Rai.47fea49d.svg";